import classNames from 'classnames'
import React from 'react'
import { Card } from 'react-bootstrap'

import UnhandledErrorMessage from './UnhandledErrorMessage'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  error: unknown
  fallbackComponent?: React.ReactNode
  cardProps?: React.ComponentProps<typeof Card>
}

const FullPageErrorFallback: React.FC<Props> = ({
  className,
  style,
  error,
  fallbackComponent,
  cardProps,
}) => {
  if (fallbackComponent) {
    return fallbackComponent
  }

  return (
    <div
      className={classNames(
        'mt-5 p-4 mx-auto d-flex justify-content-center',
        className,
      )}
      style={{ maxWidth: '800px', ...style }}
    >
      <Card {...cardProps}>
        <Card.Body>
          <UnhandledErrorMessage error={error} />
        </Card.Body>
      </Card>
    </div>
  )
}

export default FullPageErrorFallback
